import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError } from "./notification";
import {useState} from "react";
import {IUser} from "../context/AuthProvider/types";

export async function getFooterItems() {
  let res = {
    image: "",
    name: "",
    portal: "",
    message: "",
    version: "",
    return: false
  };
  await Api.get(endpoints.getFooter+ "?date="+ Date.now().toString()).then((response) => {
    if(!response || response.data.return === false) return res
    if(response && response.data.return === true) {
      res = response.data
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}